<div class="container-fluid">
  <ng-container *ngFor="let module of routeModules | keyvalue : keepOriginalOrder">
    <div class="mb-3">
      <div class="row">
        <div class="col">
          <h1>{{ module.key | uppercase }}</h1>
        </div>
      </div>
      <div class="row">
        <ng-container *ngFor="let route of module.value">
          <div *ngIf="!route.accessAllowed || (route.accessAllowed$ | async)" class="col mb-2">
            <div class="dashboard-item" [routerLink]="route.value">
              <mat-icon class="auto">{{ route.matIcon }}</mat-icon>
              <label> {{ route.text }} </label>
            </div>
          </div>
        </ng-container>
      </div>
    </div>
  </ng-container>
</div>
